var s = { exports: {} };
export {
  s as __module
};
